import {
    format
} from "date-fns";

// Fetch JSON defensively: a non-OK response (e.g. a 500 when an Elastic index
// isn't available) or a network error returns the supplied fallback instead of
// throwing, so the UI degrades gracefully rather than crashing or hanging.
const safeFetchJson = async (url, fallback) => {
    try {
        const response = await fetch(url);
        if (!response.ok) {
            console.warn(`Request failed (${response.status}): ${url}`);
            return fallback;
        }
        return await response.json();
    } catch (e) {
        console.warn(`Request error: ${url}`, e);
        return fallback;
    }
};

const createPackageSource = (baseUrl) => {

    return {
        getDepartures: async () => {
            return await safeFetchJson(`${baseUrl}/api/packages`, []);
        },
        getDestinations: async (departureAirports) => {
            var dep = departureAirports.join('-');
            return await safeFetchJson(`${baseUrl}/api/packages/${dep}`, { countries: [] });
        },
        getDestinationsWithTextSearch: async (departureAirports, text) => {
            var dep = departureAirports.join('-');
            return await safeFetchJson(`${baseUrl}/api/packages/${dep}/search?query=${encodeURIComponent(text)}`, { destinations: [] });
        },
        getAvailableDates: async (departureAirports, destination) => {
            var dep = departureAirports.join('-');
            return await safeFetchJson(`${baseUrl}/api/packages/${dep}/${destination}`, {});
        },
        getReturnDates: async (departureAirports, destination, date) => {
            var dep = departureAirports.join('-');
            return await safeFetchJson(`${baseUrl}/api/packages/${dep}/${destination}/${format(date, "yyyy-MM-dd")}`, []);
        },
        getDurationsForRange: async (departureAirports, destination, startDate, endDate) => {
            var dep = departureAirports.join('-');
            return await safeFetchJson(`${baseUrl}/api/packages/${dep}/${destination}/${format(startDate, "yyyy-MM-dd")}/${format(endDate, "yyyy-MM-dd")}`, []);
        },
        validate: async (departureAirports, destination, savedStartDate, savedToDate, isWindow) => {
            if (destination === undefined) {
                destination = "null";
            }
            var dep = departureAirports.join('-');
            return await safeFetchJson(
                `${baseUrl}/api/packages/validate/${dep}/${destination}/${format(savedStartDate, "yyyy-MM-dd")}/${format(savedToDate, "yyyy-MM-dd")}${isWindow ? "?window=true" : ""}`,
                { isValidDeparture: false, isValidDestination: false, isValidDates: false }
            );
        }
    }
}

// Hotel only ("stay only") source. Methods keep the same signatures as the
// package source so the picker components work unchanged - the
// departureAirports argument is accepted but ignored.
const createHotelOnlySource = (baseUrl) => {

    return {
        getDepartures: async () => {
            return [];
        },
        getDestinations: async (departureAirports) => {
            return await safeFetchJson(`${baseUrl}/api/stays`, { countries: [] });
        },
        getDestinationsWithTextSearch: async (departureAirports, text) => {
            return await safeFetchJson(`${baseUrl}/api/stays/search?query=${encodeURIComponent(text)}`, { destinations: [] });
        },
        getAvailableDates: async (departureAirports, destination) => {
            return await safeFetchJson(`${baseUrl}/api/stays/${destination}`, {});
        },
        getReturnDates: async (departureAirports, destination, date) => {
            return await safeFetchJson(`${baseUrl}/api/stays/${destination}/${format(date, "yyyy-MM-dd")}`, []);
        },
        getDurationsForRange: async (departureAirports, destination, startDate, endDate) => {
            return await safeFetchJson(`${baseUrl}/api/stays/${destination}/${format(startDate, "yyyy-MM-dd")}/${format(endDate, "yyyy-MM-dd")}`, []);
        },
        validate: async (departureAirports, destination, savedStartDate, savedToDate, isWindow) => {
            if (destination === undefined) {
                destination = "null";
            }
            return await safeFetchJson(
                `${baseUrl}/api/stays/validate/${destination}/${format(savedStartDate, "yyyy-MM-dd")}/${format(savedToDate, "yyyy-MM-dd")}${isWindow ? "?window=true" : ""}`,
                { isValidDeparture: false, isValidDestination: false, isValidDates: false }
            );
        }
    }
}

const getDataSource = (source, baseUrl) => {
    if (source == "packages") {
        return createPackageSource(baseUrl);
    }
    if (source == "stays") {
        return createHotelOnlySource(baseUrl);
    }
}

export default { getDataSource };
